import { useReducer, useCallback } from "react";
import { matchFormReducer, initialState } from "../reducers/matchFormReducer";
import { updateMatchByPlayer, updateMatchByAdmin } from "../services/matchService";
import { useNavContext } from "../context/nav_context";

const useMatchForm = (match) => {
  const { accessToken } = useNavContext();
  const [state, dispatch] = useReducer(matchFormReducer, initialState);

  const getCurrentMatchId = useCallback(
    () => state._match?.matchId || state._match?._id || state._match?.id,
    [state._match]
  );

  const initForm = useCallback(() => {
    if (match) {
      dispatch({ type: "INIT_MATCH", payload: match });
    }
  }, [match]);

  const publish = useCallback(async () => {
    const matchId = getCurrentMatchId();
    if (!matchId) return false;

    const preparedMatchDate = state.matchDate
      ? new Date(state.matchDate).toISOString()
      : "";

    const payload = {
      ...state._match,
      mapDraft: state.mapDraft,
      civDraft: state.civDraft,
      status: state.matchStatus,
      playerAresult: state.matchResultA,
      playerBresult: state.matchResultB,
      playerAaw: state.playerAaw,
      playerBaw: state.playerBaw,
      matchDate: preparedMatchDate,
      games: state.games,
    };

    try {
      const updatedMatch = await updateMatchByPlayer(matchId, payload, accessToken);
      dispatch({ type: "PUBLISH_ACK", payload: updatedMatch });
      return true;
    } catch {
      return false;
    }
  }, [state, accessToken, getCurrentMatchId]);

  const publishAdmin = useCallback(async () => {
    const matchId = getCurrentMatchId();
    if (!matchId) return false;

    const preparedMatchDate = state.matchDate
      ? new Date(state.matchDate).toISOString()
      : "";

    const payload = {
      ...state._match,
      mapDraft: state.mapDraft,
      civDraft: state.civDraft,
      status: state.matchStatus,
      playerAresult: state.matchResultA,
      playerBresult: state.matchResultB,
      playerAaw: state.playerAaw,
      playerBaw: state.playerBaw,
      matchDate: preparedMatchDate,
      games: state.games,
    };

    try {
      const updatedMatch = await updateMatchByAdmin(matchId, payload, accessToken);
      dispatch({ type: "PUBLISH_ACK", payload: updatedMatch });
      return true;
    } catch {
      return false;
    }
  }, [state, accessToken, getCurrentMatchId]);

  return {
    state,
    dispatch,
    initForm,
    publish,
    publishAdmin,
  };
};

export default useMatchForm;
